import { connect } from "react-redux";
import { editUser } from "./actions/users";

import UserListItem from "./UserListItem";
import { SORT_BY } from "./actions/sort";

const mapStateToProps = (state, ownProps) => {
  return {
    showRole: state.ui.sortPeople !== SORT_BY.ROLE
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onEditUser: () => {
      dispatch(editUser(ownProps.user.id));
    }
  };
};

const UserListItemContainer = connect(mapStateToProps, mapDispatchToProps)(
  UserListItem
);

export default UserListItemContainer;



// WEBPACK FOOTER //
// ./src/UserListItemContainer.js